/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import LoginWizardDumb from './LoginWizardDumb';
import { resetAuthenticationLoginSection } from 'src/shared/app/authentication/action/base/uiAuthenticationActions';
import {
  isPasswordSet,
  isPasswordReset,
} from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import { getAuthenticationLoginSection } from 'src/shared/app/authentication/selector/base/uiAuthenticationSelectors';
import withMount from 'src/shared/app/base/component/hoc/withMount';

const mapStateToProps = (state: Object): Object => ({
  section: getAuthenticationLoginSection(state),
  isPasswordSet: isPasswordSet(state),
  isPasswordReset: isPasswordReset(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => ({
  ...stateProps,
  handleMount() {
    dispatch(resetAuthenticationLoginSection());
  },
  handleBack() {
    dispatch(resetAuthenticationLoginSection());
  },
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withMount,
)(LoginWizardDumb);
